import React, { useState } from "react";

import styled, { css } from "styled-components";

import { Button } from "@chakra-ui/react";
import { MinusIcon, QuestionOutlineIcon } from "@chakra-ui/icons";

const SupportButton = styled(Button)`
  background-color: #000 !important;
  position: fixed !important;
  right: 20px;
  bottom: 40px;
  color: #fff !important;
  z-index: 9999999999;
  margin-left: 20px;
  border-radius: 999rem !important;
  padding: 22px 24px !important;
  font-weight: bold !important;
  font-size: 1.07143rem !important;
  &:active,
  &:focus {
    box-shadow: none !important;
    outline: 2px solid grey !important;
    outline-offset: 0px;
  }
  letter-spacing: 0.6 !important;
  transform: translateY(0);
  opacity: 1;
  transition: opacity 0.5s ease-out, transform 0.5s ease-out !important;
  ${(props) =>
    props.$showNotification &&
    css`
        opacity 0;
        transform: translateY(42px);
        pointer-events: none;
    `};
`;

const Container = styled.div<{ $showNotification: boolean }>`
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  position: fixed !important;
  right: 16px;
  bottom: 40px;
  z-index: 9999999999;
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s 0.25s ease-out;
  width: 340px;
  height: 340px;
  overflow: hidden;

  ${(props) =>
    props.$showNotification &&
    css`
      visibility: visible;
      opacity: 1;
    `};
`;

const Header = styled.div`
  background-color: #000;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 20px;
`;

const Body = styled.div`
  flex: 1;
  background-color: #fff;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  color: rgb(47, 57, 65);
  font-size: 14px !important;
  font-weight: bold;
  gap: 20px;
`;

const SupportNotification = (): React.ReactElement => {
  const [showNotification, setShowNotification] = useState(false);

  return (
    <>
      <SupportButton
        $showNotification={showNotification}
        onClick={() => setShowNotification(!showNotification)}
      >
        <QuestionOutlineIcon width={5} height={5} marginRight={2} /> Support
      </SupportButton>

      <Container $showNotification={showNotification}>
        <Header>
          <MinusIcon onClick={() => setShowNotification(false)} />
        </Header>
        <Body>
          <div>
            We are currently testing improvements to our support workflow, so
            our ticket feature is temporarily unavailable.
          </div>
          <div>
            For inquiries, please contact us via email at support@alpaca.markets
          </div>
        </Body>
      </Container>
    </>
  );
};

export default SupportNotification;
